import { create } from 'zustand';

interface ApiLoadingState {
  activeRequests: number;
  isVisible: boolean;
  progress: number;
  requestStarted: () => void;
  requestFinished: () => void;
  reset: () => void;
}

let progressInterval: ReturnType<typeof setInterval> | null = null;
let hideTimeout: ReturnType<typeof setTimeout> | null = null;

const stopProgressInterval = () => {
  if (progressInterval) {
    clearInterval(progressInterval);
    progressInterval = null;
  }
};

const clearHideTimeout = () => {
  if (hideTimeout) {
    clearTimeout(hideTimeout);
    hideTimeout = null;
  }
};

export const useApiLoadingStore = create<ApiLoadingState>((set, get) => ({
  activeRequests: 0,
  isVisible: false,
  progress: 0,

  requestStarted: () => {
    const { activeRequests, isVisible } = get();

    clearHideTimeout();

    set({
      activeRequests: activeRequests + 1,
      isVisible: true,
      progress: isVisible ? get().progress : 12,
    });

    if (!progressInterval) {
      progressInterval = setInterval(() => {
        const current = get();

        if (current.activeRequests <= 0) {
          stopProgressInterval();
          return;
        }

        set((state) => ({
          progress: Math.min(state.progress + (Math.random() * 8 + 2), 90),
        }));
      }, 180);
    }
  },

  requestFinished: () => {
    const { activeRequests } = get();
    const nextRequests = Math.max(activeRequests - 1, 0);

    set({ activeRequests: nextRequests });

    if (nextRequests === 0) {
      stopProgressInterval();
      set({ progress: 100 });

      clearHideTimeout();
      hideTimeout = setTimeout(() => {
        set({ isVisible: false, progress: 0 });
      }, 280);
    }
  },

  reset: () => {
    stopProgressInterval();
    clearHideTimeout();
    set({ activeRequests: 0, isVisible: false, progress: 0 });
  },
}));
